import { inject, observer } from "mobx-react";
import { Layout as AntdLayout, Spin } from "antd";
import React from "react";

import PageStore from "app/PageStore";
import Sidebar from "components/Sidebar";
import styled from "@emotion/styled";

import Alert from "./Alert";

const { Content } = AntdLayout;

const LayoutWrapper = styled(AntdLayout)`
  height: 100%;
  min-height: 100vh;
`;

interface LayoutProps extends React.HTMLProps<HTMLElement> {
  pageStore?: PageStore;
}

const Layout = inject("pageStore")(
  observer(({ children, pageStore }: LayoutProps) => {
    const {
      isSpinnerShow,
      isAlertShow,
      // isPromptShow,
      // isSpinnerBlocking,
      spinnerMessage,
    } = pageStore!;
    return (
      <Spin
        spinning={isSpinnerShow}
        wrapperClassName="spinner"
        tip={spinnerMessage}
      >
        <LayoutWrapper hasSider>
          <Sidebar />
          <Content id="main">{children}</Content>
          {isAlertShow && <Alert />}
          {/* {isPromptShow && <Prompt />} */}
        </LayoutWrapper>
      </Spin>
    );
  }),
);

export default Layout;
